<template>
  <div>
    <div class="current-position">
      <img class="common-banner2" src="../assets/img/banner.png" alt="">
      <div class="current-position-text">
        <div class="common-container">
          <div class="current-position-logotext">Search Article</div>
        </div>
        <div class="common-container">
          当前位置: 首页  >  {{ menu.title }}
        </div>
      </div>
    </div>
    <div class="survey-module">
      <div class="common-container justify-between">
        <div class="survey-module-right" v-show="!detail_show">
          <div class="survey-module-right-title f-w justify-between">
            <span>搜索</span>
            <div class="search-input justify-between"> 
            <input type="text" v-model="queryParams.keywords" placeholder="请输入" />
            <div class="search-input-btn justify-center align-center" @click="queryParams.pageNum=1,getFun()">
              <i class="el-icon-search"></i>
            </div>
          </div>
          </div>
          <div class="survey-module-right-action">
            <div class="new-list" v-if="menu_action.length>0">
              <div class="new-item justify-between" v-for="(item,index) in menu_action" :key="index" @click="openDetail(item)">
                <div class="new-item-img-box">
                  <img :src="$baseUrl+item.thumbnailUrl" alt="">
                </div>
                <div class="new-item-content flex-col justify-between" v-if="item.address">
                  <span class="new-item-content-title">{{ item.title }}</span>
                  <span>{{ item.address }}</span>
                  <span>{{ item.startTime}} ~ {{ item.endTime}}</span>
                </div>
                <div class="new-item-content flex-col justify-between" v-else>
                  <span class="new-item-content-title">{{ item.title }}</span>
                  <span>{{ item.synopsis }}</span>
                  <span>{{ item.createTime }}</span>
                </div> 
              </div>
              <div class="pagination-content justify-end">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-size="queryParams.pageSize"
                  background
                  layout="total,prev, pager, next, jumper"
                  prev-text="上一页"
                  next-text="下一页"
                  :total="total">
                </el-pagination>
              </div>
            </div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
        <div class="survey-module-right" v-show="detail_show">
          <span class="deatil-back" @click="offDetail()">返回</span>
          <div class="survey-module-right-title f-w justify-between">
            <span class="survey-module-right-title-left">{{ detail_obj.title }}</span>
            <span class="survey-module-right-title-right justify-end">{{ detail_obj.createTime }}</span>
          </div>
          <div class="survey-module-right-action">
            <div class="new-detail" v-html="detail_obj.content" v-if="detail_obj.content"></div>
            <el-empty class="survey-module-right-action-empty" v-else description="暂无内容"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getList} from "@/api/search";
export default {
  data(){
    return{
      menu:{
        title:'搜索',
        list:[
          {name:'搜索',id:'1'},
        ]
      },
      menu_action:[],
      queryParams:{
        pageNum: 1,
        pageSize: 10,
        keywords: "",
      },
      total:0,
      detail_show:false,
      detail_obj:{
        title:'',
        content:'',
        createTime:''
      }
    }
  },
  created(){
    this.getFun()
  },
  methods:{
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.queryParams.pageNum = val
      this.getFun()
    },
    getFun(){
      getList(this.queryParams)
      .then(({ data }) => {
        this.menu_action = data.list;
        this.total = data.total;
      })
      .finally(() => {});
    },
    // openDetail(id){
    //   let pathHerf = this.$router.resolve({
    //     path:'/detailPage',query:{detail_id:id,type:1,name:'搜索'}
    //   })
    //   window.open(pathHerf.href, '_self');
    // }
    openDetail(row){
      this.detail_show = true
      this.detail_obj = row
      this.detail_obj.content = this.detail_obj.content.replace(/<img/g, "<img style='max-width:100%;height:auto;'")
      this.detail_obj.content = this.detail_obj.content.replace(/<video/g, "<video style='max-width:100%;height:auto;'")
      window.scrollTo(0,0);
    },
    offDetail(){
      if('detail_id' in this.$route.query){
        this.$router.go(-1)
      }else{
        this.detail_show = false
        this.detail_obj = {
          title:'',
          content:'',
          createTime:''
        }
      }
    }
  }
}
</script>
<style scoped lang="css" src="../assets/css/rem.css" />
<style scoped>

</style>
